import { SvgIcon } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { ToggleableIconProps } from "@/src/types/IconProps";
import { getIconColor } from "@/src/services/iconService";

const IconNoOvertime = ({ active = false, sx = {} }: ToggleableIconProps) => {
  const theme = useTheme();

  return (
    <SvgIcon sx={sx} viewBox="0 0 300 300">
      <path
        style={{ fill: getIconColor(active, theme) }}
        d="m150.57,130.27l-.17-54.81c0-2.97-2.42-5.38-5.39-5.38h-.02c-2.98,0-5.39,2.43-5.38,5.41l.17,54.63c-2.1.74-4.03,1.91-5.69,3.5-4.88,4.69-6.06,11.79-3.52,17.67l-35.27,33.59c-2.16,2.05-2.24,5.47-.19,7.62,1.06,1.11,2.48,1.67,3.91,1.67,1.34,0,2.67-.49,3.72-1.49l35.26-33.58c2.07,1.03,4.34,1.6,6.72,1.65.09,0,.18,0,.28,0,4.1,0,7.98-1.56,10.95-4.41,3.03-2.92,4.75-6.84,4.83-11.04.08-4.2-1.48-8.19-4.4-11.22-1.66-1.72-3.64-3.01-5.81-3.83Zm-2.1,18.31c-.96.93-2.22,1.44-3.56,1.4-1.33-.02-2.56-.56-3.48-1.51-1.91-1.99-1.85-5.16.14-7.07.93-.89,2.14-1.38,3.42-1.38.04,0,.07,0,.11,0,1.33.03,2.57.58,3.51,1.55.92.96,1.41,2.21,1.39,3.53-.03,1.32-.57,2.55-1.52,3.47Z"
      />
      <path
        style={{ fill: getIconColor(active, theme) }}
        d="m144.86,64.32h0c2.97,0,5.39-2.43,5.38-5.41,0-2.97-2.42-5.39-5.4-5.38-2.98,0-5.39,2.42-5.38,5.4,0,2.98,2.42,5.39,5.4,5.39Z"
      />
      <path
        style={{ fill: getIconColor(active, theme) }}
        d="m231.07,150.39c2.98,0,5.39-2.42,5.39-5.39v-.21h0c0-2.99-2.42-5.39-5.4-5.38-2.98,0-5.39,2.42-5.38,5.4v.19c0,2.97,2.41,5.39,5.39,5.39Z"
      />
      <path
        style={{ fill: getIconColor(active, theme) }}
        d="m67.69,106.73c.85.49,1.78.72,2.69.72,1.87,0,3.68-.97,4.68-2.7,1.49-2.58.6-5.88-1.98-7.37-2.58-1.49-5.88-.6-7.37,1.98-1.48,2.58-.6,5.87,1.98,7.37Z"
      />
      <path
        style={{ fill: getIconColor(active, theme) }}
        d="m58.92,139.7c-2.98,0-5.39,2.42-5.39,5.4s2.42,5.39,5.4,5.39c2.98,0,5.39-2.42,5.39-5.4-.01-2.98-2.42-5.39-5.4-5.39Z"
      />
      <path
        style={{ fill: getIconColor(active, theme) }}
        d="m145.04,225.68c-2.97,0-5.39,2.41-5.39,5.39s2.42,5.39,5.4,5.39,5.39-2.41,5.39-5.39-2.42-5.4-5.4-5.39Z"
      />
      <path
        style={{ fill: getIconColor(active, theme) }}
        d="m104.71,214.91c-2.58-1.49-5.88-.61-7.37,1.97-1.49,2.58-.61,5.88,1.97,7.37.85.49,1.78.73,2.69.73,1.87,0,3.68-.97,4.68-2.7,1.49-2.58.61-5.88-1.97-7.37Z"
      />
      <path
        style={{ fill: getIconColor(active, theme) }}
        d="m101.85,75.9c.92,0,1.85-.23,2.7-.73,2.58-1.49,3.45-4.8,1.96-7.37-1.5-2.58-4.8-3.45-7.37-1.96-2.58,1.5-3.46,4.8-1.96,7.38,1,1.72,2.81,2.68,4.67,2.68Z"
      />
      <path
        style={{ fill: getIconColor(active, theme) }}
        d="m185.21,75.03h0c.84.49,1.77.73,2.68.73,1.87,0,3.68-.97,4.68-2.71,1.49-2.58.6-5.88-1.98-7.36-2.58-1.49-5.88-.6-7.36,1.98-1.49,2.58-.61,5.88,1.98,7.36Z"
      />
      <path
        style={{ fill: getIconColor(active, theme) }}
        d="m219.47,107.19c.92,0,1.85-.23,2.7-.73,2.58-1.49,3.45-4.8,1.95-7.37-1.49-2.58-4.79-3.45-7.37-1.95-2.57,1.49-3.45,4.79-1.95,7.37,1,1.72,2.81,2.68,4.67,2.68Z"
      />
      <path
        style={{ fill: getIconColor(active, theme) }}
        d="m67.78,183.44c-2.58,1.5-3.46,4.8-1.96,7.37,1,1.73,2.81,2.69,4.67,2.69.92,0,1.85-.23,2.7-.73,2.58-1.49,3.45-4.79,1.96-7.37-1.49-2.57-4.79-3.45-7.37-1.96Z"
      />
      <path
        style={{ fill: getIconColor(active, theme) }}
        d="m63.35,49.23c1.19,0,2.39-.39,3.39-1.2.99-.8,2-1.59,3.02-2.36,2.37-1.8,2.83-5.19,1.03-7.56-1.8-2.37-5.19-2.83-7.56-1.03-1.1.84-2.19,1.69-3.27,2.55-2.32,1.87-2.68,5.27-.81,7.58,1.07,1.32,2.63,2,4.2,2Z"
      />
      <path
        style={{ fill: getIconColor(active, theme) }}
        d="m274.12,185.77c4.07-12.87,6.28-26.57,6.28-40.77,0-74.66-60.74-135.39-135.39-135.39-23.94,0-47.47,6.33-68.05,18.32-2.57,1.5-3.45,4.8-1.95,7.38,1.5,2.57,4.8,3.45,7.38,1.95,18.93-11.03,40.58-16.85,62.62-16.85,68.71,0,124.61,55.9,124.61,124.61,0,11.31-1.52,22.26-4.36,32.69-3.09-2.32-6.36-4.34-9.79-6.03,8.73-36.44-.68-76.46-28.53-105.42-43.44-45.18-115.53-46.59-160.7-3.16-45.18,43.44-46.58,115.54-3.14,160.72,21.04,21.88,49.34,34.26,79.69,34.85.76.01,1.51.02,2.27.02,9.09,0,18.02-1.07,26.65-3.14,1.68,3.4,3.69,6.65,5.99,9.72-10.42,2.84-21.38,4.36-32.69,4.36-68.71,0-124.61-55.9-124.61-124.61,0-31.09,11.52-60.87,32.44-83.85,2-2.2,1.84-5.61-.36-7.62-2.2-2.01-5.61-1.84-7.62.36-22.73,24.97-35.25,57.33-35.25,91.12,0,74.66,60.74,135.39,135.39,135.39,14.2,0,27.89-2.2,40.76-6.27,11.21,10.21,25.55,15.96,40.84,16.26.42,0,.83.01,1.25.01,16.25,0,31.6-6.18,43.35-17.48,24.44-23.5,25.59-62.22,2.92-87.15Zm-106.38,59.6c-8.03,1.81-16.33,2.66-24.75,2.49-27.47-.53-53.08-11.74-72.13-31.54-39.32-40.89-38.05-106.15,2.84-145.47,19.91-19.15,45.6-28.66,71.26-28.66,27.02,0,54.02,10.56,74.18,31.53,24.85,25.84,33.47,61.41,26.14,94.01-5.22-1.51-10.67-2.36-16.24-2.47-16.75-.35-32.54,5.87-44.59,17.46-12.05,11.59-18.87,27.17-19.19,43.88-.13,6.44.73,12.75,2.48,18.77Zm95.98,19.77c-9.97,9.59-23.1,14.72-36.91,14.46-13.83-.27-26.72-5.91-36.31-15.88-9.59-9.97-14.73-23.08-14.46-36.91.27-13.83,5.91-26.73,15.89-36.32,9.72-9.35,22.42-14.46,35.85-14.46.35,0,.7,0,1.04,0,13.83.27,26.72,5.92,36.32,15.89,19.79,20.58,19.15,53.42-1.43,73.2Z"
      />
      <path
        style={{ fill: getIconColor(active, theme) }}
        d="m248.62,207.02c-2.11-2.11-5.52-2.11-7.63,0l-13.17,13.17-13.17-13.17c-2.11-2.11-5.52-2.11-7.63,0-2.11,2.11-2.11,5.52,0,7.63l13.17,13.17-13.17,13.17c-2.11,2.11-2.11,5.52,0,7.63,1.05,1.05,2.43,1.58,3.81,1.58s2.76-.53,3.81-1.58l13.17-13.17,13.17,13.17c1.05,1.05,2.43,1.58,3.81,1.58s2.76-.53,3.81-1.58c2.11-2.11,2.11-5.52,0-7.63l-13.17-13.17,13.17-13.17c2.11-2.11,2.11-5.52,0-7.63Z"
      />
    </SvgIcon>
  );
};

export default IconNoOvertime;